import { postCatalogProductsMetricsCollect } from 'data-api'
import { BH_SEARCH_ID } from '../../constants'
import { getClient } from './client'
import { getConstantParams } from './utils/bh-search-constants'

export const addToCart = async ({ product, userUniqueId, isLoggedIn, getCookiesByStore }) => {
	const cookies = getCookiesByStore()
	if (cookies[BH_SEARCH_ID]) {
		try {
			await postCatalogProductsMetricsCollect({
				client: getClient(),
				event: 'cart',
				eventName: 'addToCart',
				itemIds: [],
				extItemIds: [product?.sku],
				...getConstantParams({ userUniqueId, isLoggedIn, getCookiesByStore }),
			})
		} catch (e) {
			console.error(e)
		}
	}
}
